<!-- src/views/pages/applications/email-index.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content p-0">
      <div class="d-md-flex">
        <!-- =========================
             LEFT SIDEBAR
        ========================== -->
        <div class="email-sidebar border-end border-bottom">
          <div class="active slimscroll h-100">
            <div class="slimscroll-active-sidebar">
              <div class="p-3">
                <!-- Profile card (dynamic) -->
                <div class="shadow-md bg-white rounded p-2 mb-4">
                  <div class="d-flex align-items-center">
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md flex-shrink-0 me-2"
                    >
                      <img
                        v-if="currentUser.avatar"
                        :src="currentUser.avatar"
                        class="rounded-circle"
                        alt=""
                      />
                      <span
                        v-else
                        class="avatar-title rounded-circle bg-primary text-white"
                      >
                        {{ initials(currentUser.name || "NA") }}
                      </span>
                    </a>

                    <div class="flex-fill">
                      <h6 class="mb-1">
                        <a href="javascript:void(0);">{{
                          currentUser.name || "—"
                        }}</a>
                      </h6>
                      <p class="mb-0 text-truncate">
                        {{ currentUser.email || "—" }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Compose -->
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary w-100"
                  @click="openCompose"
                >
                  <i class="ti ti-edit me-2"></i>Compose
                </a>

                <!-- Emails folders -->
                <div class="mt-4">
                  <h5 class="mb-2">Emails</h5>
                  <div class="d-block mb-4 pb-4 border-bottom email-tags">
                    <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'inbox' }"
                      @click="onFolderClick('inbox')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-inbox text-gray me-2"></i>Inbox</span
                      >
                      <span class="badge badge-danger rounded-pill badge-xs">
                        {{ emailStore.counts.inbox.unread }}
                      </span>
                    </a>

                    <!-- <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'starred' }"
                      @click="onFolderClick('starred')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-star text-gray me-2"></i>Starred</span
                      >
                      <span class="fw-semibold fs-12 badge text-gray rounded-pill"
                        >0</span
                      >
                    </a> -->

                    <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'sent' }"
                      @click="onFolderClick('sent')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-rocket text-gray me-2"></i>Sent</span
                      >
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.sent.total }}
                      </span>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'drafts' }"
                      @click="onFolderClick('drafts')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-file text-gray me-2"></i>Drafts</span
                      >
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.drafts.total }}
                      </span>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'trash' }"
                      @click="onFolderClick('trash')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-trash text-gray me-2"></i>Deleted</span
                      >
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.trash.total }}
                      </span>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                      :class="{ active: activeFolder === 'spam' }"
                      @click="onFolderClick('spam')"
                    >
                      <span class="d-flex align-items-center fw-medium"
                        ><i class="ti ti-info-octagon text-gray me-2"></i
                        >Spam</span
                      >
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.spam.total }}
                      </span>
                    </a>
                  </div>
                </div>

                <!-- =========================
                     LABELS
                ========================== -->
                <div class="border-bottom mb-4 pb-4">
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <h5 class="mb-0">Labels</h5>

                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#email_label_modal"
                      title="Create label"
                      class="text-decoration-none"
                    >
                      <i
                        class="ti ti-square-rounded-plus-filled text-primary fs-16"
                      ></i>
                    </a>
                  </div>

                  <!-- Active filter pill -->
                  <div
                    v-if="activeLabel"
                    class="mb-2 d-flex align-items-center gap-2"
                  >
                    <span
                      class="badge rounded-pill"
                      :style="activeLabelPillStyle"
                    >
                      <i class="ti ti-square me-1"></i>{{ activeLabel.name }}
                    </span>

                    <a
                      href="javascript:void(0);"
                      class="small text-primary fw-medium"
                      @click.prevent="clearLabelFilter"
                    >
                      Clear
                    </a>
                  </div>

                  <div v-if="emailStore.loadingLabels" class="text-muted small">
                    Loading labels...
                  </div>

                  <div v-else>
                    <a
                      v-for="l in emailStore.labels"
                      :key="l.id"
                      href="javascript:void(0);"
                      class="fw-medium d-flex align-items-center text-dark py-1"
                      @click.prevent="onLabelClick(l.id)"
                      :class="{
                        'opacity-75': emailStore.activeLabelId === l.id,
                      }"
                    >
                      <i
                        class="ti ti-square-rounded me-2"
                        :style="{ color: l.color || '#6c757d' }"
                      ></i>
                      <span class="text-truncate">{{ l.name }}</span>
                      <span
                        v-if="l.unread_count != null"
                        class="ms-auto badge text-gray rounded-pill"
                      >
                        {{ l.unread_count }}
                      </span>
                    </a>

                    <div
                      v-if="emailStore.labels.length === 0"
                      class="text-muted small"
                    >
                      No labels yet. Create one using +.
                    </div>
                  </div>
                </div>

                <!-- Upgrade banner (kept) -->
                <!-- <div class="bg-dark rounded text-center position-relative p-4">
                  <span class="avatar avatar-lg rounded-circle bg-white mb-2">
                    <i class="ti ti-alert-triangle text-dark"></i>
                  </span>
                  <h6 class="text-white mb-3">
                    Enjoy Unlimited Access on a small price monthly.
                  </h6>
                  <a href="javascript:void(0);" class="btn btn-white"
                    >Upgrade Now <i class="ti ti-arrow-right"></i
                  ></a>
                  <div class="box-bg">
                    <span class="bg-right"
                      ><img src="@/assets/img/bg/email-bg-01.png" alt=""
                    /></span>
                    <span class="bg-left"
                      ><img src="@/assets/img/bg/email-bg-02.png" alt=""
                    /></span>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- =========================
             MIDDLE LIST
        ========================== -->
        <div
          class="bg-white flex-fill border-end border-bottom mail-notifications"
        >
          <div class="active slimscroll h-100">
            <div class="slimscroll-active-sidebar">
              <div class="p-3">
                <div
                  class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
                >
                  <div>
                    <h5 class="mb-1">{{ inboxTitle }}</h5>
                    <div class="d-flex align-items-center">
                      <span>{{ inboxTotal }} Emails</span>
                      <i class="ti ti-point-filled text-primary mx-1"></i>
                      <span>{{ inboxUnread }} Unread</span>
                    </div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="position-relative input-icon me-3">
                      <span class="input-icon-addon"
                        ><i class="ti ti-search"></i
                      ></span>
                      <input
                        v-model="searchInput"
                        type="text"
                        class="form-control"
                        placeholder="Search Email"
                      />
                    </div>

                    <div class="d-flex align-items-center">
                      <a
                        href="javascript:void(0);"
                        class="btn btn-icon btn-sm rounded-circle"
                        title="Refresh"
                        @click="onRefresh"
                      >
                        <i class="ti ti-refresh"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="list-group list-group-flush mails-list">
                <div v-if="loading" class="p-3 text-muted">
                  Loading emails...
                </div>

                <div
                  v-for="item in emails"
                  :key="item.id"
                  class="list-group-item border-bottom p-3"
                  :class="{ 'bg-light': !item.is_read }"
                >
                  <div class="d-flex align-items-center mb-2">
                    <div
                      class="form-check form-check-md d-flex align-items-center flex-shrink-0 me-2"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="isSelected(item.id)"
                        @change="toggleSelect(item.id)"
                      />
                    </div>

                    <div
                      class="d-flex align-items-center flex-wrap row-gap-2 flex-fill"
                    >
                      <a
                        href="javascript:void(0);"
                        class="avatar avatar-rounded me-2"
                        @click.prevent="openEmail(item)"
                        :class="{ 'bg-purple': !item.sender?.avatar }"
                        style="cursor: pointer"
                      >
                        <img
                          v-if="item.sender?.avatar"
                          :src="item.sender.avatar"
                          alt=""
                        />
                        <span v-else class="avatar-title">
                          {{ initials(item.sender?.name || "NA") }}
                        </span>
                      </a>

                      <div class="flex-fill">
                        <div
                          class="d-flex align-items-start justify-content-between"
                        >
                          <div>
                            <h6 class="mb-1">
                              <a
                                href="javascript:void(0);"
                                @click.prevent="openEmail(item)"
                              >
                                {{ item.sender?.name || "Unknown Sender" }}
                              </a>
                            </h6>
                            <span class="fw-semibold">{{
                              item.subject || "No Subject"
                            }}</span>
                          </div>

                          <div class="d-flex align-items-center gap-2">
                            <a
                              href="javascript:void(0);"
                              class="btn btn-icon btn-sm rounded-circle"
                              title="Delete"
                              @click.prevent="onDeleteEmail(item)"
                            >
                              <i class="ti ti-trash"></i>
                            </a>

                            <span class="text-nowrap">
                              <i
                                class="ti ti-point-filled"
                                :class="
                                  item.is_read ? 'text-success' : 'text-danger'
                                "
                              ></i>
                              {{ formatTime(item.created_at) }}
                            </span>
                          </div>
                        </div>

                        <p class="mb-0">{{ item.snippet || "" }}</p>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <span
                        v-if="(item.attachments_count || 0) > 0"
                        class="d-flex align-items-center btn btn-sm bg-transparent-dark me-2"
                      >
                        <i class="ti ti-paperclip me-2"></i
                        >{{ item.attachments_count }}
                      </span>
                    </div>

                    <div class="d-flex align-items-center">
                      <span v-if="item.labels?.length">
                        <span
                          v-for="l in item.labels.slice(0, 2)"
                          :key="l.id"
                          class="badge mx-1"
                          :style="labelPillStyle(l)"
                        >
                          <i class="ti ti-square me-1"></i>{{ l.name }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!loading && emails.length === 0"
                  class="p-3 text-muted"
                >
                  No emails found.
                </div>
              </div>

              <!-- Pagination -->
              <div class="p-3 border-top" v-if="meta.total > meta.per_page">
                <div
                  class="d-flex align-items-center justify-content-between flex-wrap gap-2"
                >
                  <div class="text-muted small">
                    Page {{ meta.current_page }} of {{ meta.last_page }}
                  </div>

                  <div class="d-flex align-items-center gap-2">
                    <button
                      class="btn btn-white btn-sm"
                      :disabled="meta.current_page <= 1 || loading"
                      @click="goPage(meta.current_page - 1)"
                    >
                      <i class="ti ti-chevron-left me-1"></i>Prev
                    </button>

                    <button
                      class="btn btn-white btn-sm"
                      :disabled="meta.current_page >= meta.last_page || loading"
                      @click="goPage(meta.current_page + 1)"
                    >
                      Next<i class="ti ti-chevron-right ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- /Pagination -->
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div
        class="footer d-sm-flex align-items-center justify-content-between bg-white p-3"
      >
        <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
        <p class="mb-0">
          Powered by
          <a href="javascript:void(0);" class="text-primary"
            >DoneQuick Technological World</a
          >
        </p>
      </div>
    </div>
  </div>

  <!-- Create label modal -->
  <EmailLabelModal />

 <!-- =========================
      COMPOSE MODAL (UPGRADED) - COMPLETE
========================== -->
<div class="modal fade dq-compose" id="compose_mail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl dq-compose-dialog">
    <div class="modal-content dq-compose-card">
      <!-- Header -->
      <div class="modal-header dq-compose-header">
        <div class="d-flex align-items-center gap-3">
          <span class="dq-compose-icon">
            <i class="ti ti-edit"></i>
          </span>
          <div class="d-flex flex-column">
            <h5 class="modal-title mb-0">Compose Email</h5>
            <small class="dq-compose-subtitle text-truncate">
              Send a message to one or multiple recipients
            </small>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <span v-if="autosavePill" class="dq-compose-draft-pill">
            <i :class="autosavePill.icon" class="me-1"></i>{{ autosavePill.text }}
          </span>

          <button
            type="button"
            class="btn btn-icon btn-sm dq-compose-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            :disabled="emailStore.sending"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
      </div>

      <form @submit.prevent="sendNow">
        <!-- Body (scrollable) -->
        <div class="modal-body dq-compose-body">
          <!-- To -->
          <div class="mb-3 position-relative">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <label class="form-label mb-0">To</label>
              <small class="text-muted">Comma separated</small>
            </div>

            <!-- Chips row -->
            <div v-if="toList.length" class="dq-chip-row mb-2">
              <span v-for="em in toList" :key="em" class="dq-chip">
                <i class="ti ti-mail me-1"></i>
                <span class="text-truncate" style="max-width: 320px">{{ em }}</span>
                <button
                  type="button"
                  class="dq-chip-x"
                  title="Remove"
                  @click="removeEmailFromField('to', em)"
                  :disabled="emailStore.sending"
                >
                  <i class="ti ti-x"></i>
                </button>
              </span>
            </div>

            <div class="dq-input-wrap">
              <i class="ti ti-at dq-input-icon"></i>
              <input
                v-model.trim="toInput"
                class="form-control dq-input"
                placeholder="john@company.com, jane@company.com"
                @input="onRecipientInput('to')"
                @focus="onRecipientFocus('to')"
                @blur="onRecipientBlur"
                @keydown="onRecipientKeydown('to', $event)"
                :disabled="emailStore.sending"
              />
            </div>

            <!-- Suggestions -->
            <div
              v-if="showSuggest.to && filteredRecipients.length"
              class="dq-suggest shadow-sm border bg-white rounded mt-2 position-absolute w-100 dq-suggest-panel"
              @mousedown.prevent
            >
              <button
                v-for="u in filteredRecipients"
                :key="u.id"
                type="button"
                class="dropdown-item d-flex align-items-center gap-2 py-2"
                @click="pickRecipient('to', u.email)"
              >
                <span class="avatar avatar-xs dq-suggest-avatar">
                  {{ initials(u.first_name || u.name || u.email) }}
                </span>

                <span class="flex-fill text-truncate">
                  <span class="fw-semibold">{{ u.first_name || u.name || "User" }}</span>
                  <small class="text-muted d-block text-truncate">{{ u.email }}</small>
                </span>

                <i class="ti ti-arrow-up-right text-muted"></i>
              </button>
            </div>
          </div>

          <!-- Cc / Bcc -->
          <div class="row g-3">
            <!-- Cc -->
            <div class="col-md-6 position-relative">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <label class="form-label mb-0">Cc</label>
                <small class="text-muted">Optional</small>
              </div>

              <!-- Chips row -->
              <div v-if="ccList.length" class="dq-chip-row mb-2">
                <span v-for="em in ccList" :key="em" class="dq-chip">
                  <i class="ti ti-mail me-1"></i>
                  <span class="text-truncate" style="max-width: 320px">{{ em }}</span>
                  <button
                    type="button"
                    class="dq-chip-x"
                    title="Remove"
                    @click="removeEmailFromField('cc', em)"
                    :disabled="emailStore.sending"
                  >
                    <i class="ti ti-x"></i>
                  </button>
                </span>
              </div>

              <div class="dq-input-wrap">
                <i class="ti ti-users dq-input-icon"></i>
                <input
                  v-model.trim="ccInput"
                  class="form-control dq-input"
                  placeholder="cc@company.com"
                  @input="onRecipientInput('cc')"
                  @focus="onRecipientFocus('cc')"
                  @blur="onRecipientBlur"
                  @keydown="onRecipientKeydown('cc', $event)"
                  :disabled="emailStore.sending"
                />
              </div>

              <div
                v-if="showSuggest.cc && filteredRecipients.length"
                class="dq-suggest shadow-sm border bg-white rounded mt-2 position-absolute w-100 dq-suggest-panel"
                @mousedown.prevent
              >
                <button
                  v-for="u in filteredRecipients"
                  :key="u.id"
                  type="button"
                  class="dropdown-item d-flex align-items-center gap-2 py-2"
                  @click="pickRecipient('cc', u.email)"
                >
                  <span class="avatar avatar-xs dq-suggest-avatar">
                    {{ initials(u.first_name || u.name || u.email) }}
                  </span>
                  <span class="flex-fill text-truncate">
                    <span class="fw-semibold">{{ u.first_name || u.name || "User" }}</span>
                    <small class="text-muted d-block text-truncate">{{ u.email }}</small>
                  </span>
                  <i class="ti ti-arrow-up-right text-muted"></i>
                </button>
              </div>
            </div>

            <!-- Bcc -->
            <div class="col-md-6 position-relative">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <label class="form-label mb-0">Bcc</label>
                <small class="text-muted">Optional</small>
              </div>

              <!-- Chips row -->
              <div v-if="bccList.length" class="dq-chip-row mb-2">
                <span v-for="em in bccList" :key="em" class="dq-chip">
                  <i class="ti ti-mail me-1"></i>
                  <span class="text-truncate" style="max-width: 320px">{{ em }}</span>
                  <button
                    type="button"
                    class="dq-chip-x"
                    title="Remove"
                    @click="removeEmailFromField('bcc', em)"
                    :disabled="emailStore.sending"
                  >
                    <i class="ti ti-x"></i>
                  </button>
                </span>
              </div>

              <div class="dq-input-wrap">
                <i class="ti ti-lock dq-input-icon"></i>
                <input
                  v-model.trim="bccInput"
                  class="form-control dq-input"
                  placeholder="bcc@company.com"
                  @input="onRecipientInput('bcc')"
                  @focus="onRecipientFocus('bcc')"
                  @blur="onRecipientBlur"
                  @keydown="onRecipientKeydown('bcc', $event)"
                  :disabled="emailStore.sending"
                />
              </div>

              <div
                v-if="showSuggest.bcc && filteredRecipients.length"
                class="dq-suggest shadow-sm border bg-white rounded mt-2 position-absolute w-100 dq-suggest-panel"
                @mousedown.prevent
              >
                <button
                  v-for="u in filteredRecipients"
                  :key="u.id"
                  type="button"
                  class="dropdown-item d-flex align-items-center gap-2 py-2"
                  @click="pickRecipient('bcc', u.email)"
                >
                  <span class="avatar avatar-xs dq-suggest-avatar">
                    {{ initials(u.first_name || u.name || u.email) }}
                  </span>
                  <span class="flex-fill text-truncate">
                    <span class="fw-semibold">{{ u.first_name || u.name || "User" }}</span>
                    <small class="text-muted d-block text-truncate">{{ u.email }}</small>
                  </span>
                  <i class="ti ti-arrow-up-right text-muted"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Subject -->
          <div class="mt-3">
            <label class="form-label mb-1">Subject</label>
            <div class="dq-input-wrap">
              <i class="ti ti-typography dq-input-icon"></i>
              <input
                v-model="subject"
                type="text"
                class="form-control dq-input"
                placeholder="Subject"
                @input="scheduleAutosave"
                :disabled="emailStore.sending"
              />
            </div>
          </div>

          <!-- Message -->
          <div class="mt-3">
            <label class="form-label mb-1">Message</label>
            <textarea
              v-model="body"
              rows="9"
              class="form-control dq-textarea"
              placeholder="Write your message..."
              @input="scheduleAutosave"
              :disabled="emailStore.sending"
            ></textarea>
          </div>

          <!-- Dropzone -->
          <div
            class="dq-dropzone mt-3"
            :class="{ 'is-over': isDragOver, 'is-disabled': emailStore.sending }"
            @dragenter="stopDnD($event); isDragOver = true"
            @dragover="stopDnD($event); isDragOver = true"
            @dragleave="stopDnD($event); isDragOver = false"
            @drop="onDropFiles"
            @click="!emailStore.sending && pickFiles()"
          >
            <i class="ti ti-cloud-upload"></i>
            <div class="dq-dropzone-text">
              <div class="fw-semibold">Drop files here to attach</div>
              <small class="text-muted">or click to browse</small>
            </div>
          </div>

          <!-- Attachments -->
          <div class="mt-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="d-flex align-items-center gap-2">
                <span class="dq-section-title">Attachments</span>
                <small v-if="emailStore.attachmentsUploading" class="text-muted">
                  Uploading...
                </small>
              </div>

              <a
                href="javascript:void(0);"
                class="btn btn-light btn-sm d-inline-flex align-items-center dq-attach-btn"
                @click="pickFiles"
                :class="{ disabled: emailStore.sending }"
              >
                <i class="ti ti-paperclip me-2"></i>Attach files
              </a>
            </div>

            <div v-if="emailStore.attachments.length" class="dq-attach-wrap">
              <div v-for="a in emailStore.attachments" :key="a.id" class="dq-attach-pill">
                <i class="ti ti-file-text dq-attach-ic"></i>
                <span class="dq-attach-name text-truncate">
                  {{ a.original_name }}
                </span>

                <div class="dq-attach-actions">
                  <a
                    v-if="a.is_previewable"
                    href="javascript:void(0);"
                    class="dq-attach-action"
                    title="Preview"
                    @click="openPreview(a)"
                  >
                    <i class="ti ti-eye"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="dq-attach-action"
                    title="Download"
                    @click="emailStore.downloadAttachment(a)"
                  >
                    <i class="ti ti-download"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="dq-attach-action danger"
                    title="Remove"
                    @click="emailStore.deleteComposeAttachment(a.id)"
                  >
                    <i class="ti ti-x"></i>
                  </a>
                </div>
              </div>
            </div>

            <div v-else class="dq-empty-attach">
              <i class="ti ti-cloud-upload"></i>
              <div>
                <div class="fw-semibold">No attachments</div>
                <small class="text-muted">Attach PDFs, images, or documents</small>
              </div>
            </div>

            <input
              ref="fileInput"
              type="file"
              multiple
              class="d-none"
              @change="onFilesPicked"
            />
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer dq-compose-footer">
          <button
            type="button"
            class="btn btn-white dq-btn"
            :disabled="emailStore.sending"
            @click="closeCompose"
          >
            Cancel
          </button>

          <button
            type="submit"
            class="btn btn-primary dq-btn-primary d-inline-flex align-items-center"
            :disabled="emailStore.sending"
          >
            <span v-if="!emailStore.sending">
              Send <i class="ti ti-arrow-right ms-2"></i>
            </span>
            <span v-else class="d-inline-flex align-items-center gap-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Sending...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>



</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";
import { toast } from "@/utils/toast";
import { useEmailStore } from "@/stores/emailStore";
import { useAuthStore } from "@/stores/authStore";
import { useUserStore } from "@/stores/userStore";
import EmailLabelModal from "@/components/modal/email-label-modal.vue";

const router = useRouter();
const emailStore = useEmailStore();
const authStore = useAuthStore();
const userStore = useUserStore();

const currentUser = computed(() => {
  const u = authStore.user || {};
  return {
    name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || "—",
    email: u.email || "",
    avatar: u.avatar || u.photo_url || u.logo_url || "",
  };
});

const searchInput = ref("");

const activeFolder = computed(() => emailStore.activeFolder);
const emails = computed(() => emailStore.emails);
const loading = computed(() => emailStore.loadingList);
const meta = computed(() => emailStore.meta);

const inboxTitle = computed(() => emailStore.activeFolderLabel);
const inboxTotal = computed(
  () => emailStore.counts?.[emailStore.activeFolder]?.total ?? 0
);
const inboxUnread = computed(
  () => emailStore.counts?.[emailStore.activeFolder]?.unread ?? 0
);

const activeLabel = computed(() =>
  emailStore.activeLabelId
    ? emailStore.labels.find((x) => x.id === emailStore.activeLabelId) || null
    : null
);

const activeLabelPillStyle = computed(() => {
  const c = activeLabel.value?.color || "#6c757d";
  return { background: `${c}20`, color: c, border: `1px solid ${c}40` };
});

const isDragOver = ref(false);

function stopDnD(e) {
  e.preventDefault();
  e.stopPropagation();
}

async function onDropFiles(e) {
  stopDnD(e);
  isDragOver.value = false;

  const dt = e.dataTransfer;
  const files = dt?.files;
  if (!files || !files.length) return;

  await emailStore.uploadAttachments({ files, emailId: draftId.value });
}

function onFolderClick(key) {
  emailStore.setFolder(key);
  emailStore.fetchEmails();
}

function onLabelClick(id) {
  emailStore.setLabel(id);
  emailStore.fetchEmails();
}

function clearLabelFilter() {
  emailStore.setLabel(null);
  emailStore.fetchEmails();
}

function onRefresh() {
  emailStore.fetchEmails();
}

let t = null;
watch(searchInput, (v) => {
  clearTimeout(t);
  t = setTimeout(() => {
    emailStore.setSearch(v);
    emailStore.fetchEmails();
  }, 350);
});

function toggleSelect(id) {
  emailStore.toggleSelect(id);
}
function isSelected(id) {
  return emailStore.selectedIds.includes(id);
}

// function openEmail(item) {
//   emailStore.openEmail(item.id);
//   router.push(`/applications/email-reply?email_id=${item.id}`);
// }

async function openEmail(item) {
  await emailStore.fetchEmail(item.id, {
    markRead: emailStore.activeFolder !== "drafts",
  });
  router.push(`/applications/email-reply?email_id=${item.id}`);
}

function initials(name) {
  const n = String(name || "").trim();
  if (!n) return "NA";
  const parts = n.split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
}

function formatTime(dt) {
  if (!dt) return "";
  try {
    return new Date(dt).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

function labelPillStyle(label) {
  const c = label?.color || "#6c757d";
  return { background: `${c}20`, color: c, border: `1px solid ${c}40` };
}

function goPage(page) {
  emailStore.setPage(page);
  emailStore.fetchEmails();
}

/* =========================
   Compose / Draft autosave
========================= */
let composeModal = null;
let composeEl = null;

const toInput = ref("");
const ccInput = ref("");
const bccInput = ref("");
const subject = ref("");
const body = ref("");

const autosaveTimer = ref(null);
const isDraftDirty = ref(false);

const draftId = computed(() => emailStore.draftId || null);
const draftStatusText = computed(() => {
  if (emailStore.draftSaving) return "Saving draft...";
  if (draftId.value && emailStore.lastDraftSavedAt) return `Draft saved`;
  return "";
});

const nowTick = ref(Date.now());
let autosaveTicker = null;

const autosavePill = computed(() => {
  if (emailStore.draftSaving) return { text: "Saving…", icon: "ti ti-loader" };

  if (draftId.value) {
    const t = emailStore.lastDraftSavedAt
      ? new Date(emailStore.lastDraftSavedAt).getTime()
      : null;

    if (t) {
      const secs = Math.max(0, Math.floor((nowTick.value - t) / 1000));
      const label =
        secs < 5
          ? "Saved just now"
          : secs < 60
          ? `Saved ${secs}s ago`
          : secs < 3600
          ? `Saved ${Math.floor(secs / 60)}m ago`
          : "Draft saved";

      return { text: label, icon: "ti ti-device-floppy" };
    }
    return { text: "Draft", icon: "ti ti-file" };
  }

  return null;
});

function parseEmails(str) {
  if (!str) return [];
  return String(str)
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

function normalizeEmail(e) {
  return String(e || "")
    .trim()
    .toLowerCase();
}

function fieldRef(field) {
  return field === "to" ? toInput : field === "cc" ? ccInput : bccInput;
}

const toList = computed(() => parseEmails(toInput.value));
const ccList = computed(() => parseEmails(ccInput.value));
const bccList = computed(() => parseEmails(bccInput.value));

function removeEmailFromField(field, email) {
  const r = fieldRef(field);
  const target = normalizeEmail(email);

  const list = parseEmails(r.value).filter((x) => normalizeEmail(x) !== target);
  r.value = list.length ? `${list.join(", ")}, ` : "";
  scheduleAutosave();
}

// Optional: press backspace on empty token to remove last chip (premium feel)
function onRecipientKeydown(field, e) {
  if (e.key !== "Backspace") return;
  const r = fieldRef(field);
  const current = String(r.value || "");
  const token = lastToken(current);
  if (token) return;

  const list = parseEmails(current);
  if (!list.length) return;

  // remove last
  list.pop();
  r.value = list.length ? `${list.join(", ")}, ` : "";
  scheduleAutosave();
}

// ✅ hard cleanup: removes any leftover overlay + restores body scroll
function cleanupBackdrops() {
  try {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());

    // sometimes bootstrap adds aria-hidden traps; keep it clean
    document.querySelectorAll(".modal").forEach((m) => {
      m.style.removeProperty("display");
      m.removeAttribute("aria-modal");
      m.removeAttribute("role");
    });
  } catch {
    // no-op
  }
}

// ✅ close modal safely (prevents “dim page” even if bootstrap glitches)
function closeCompose() {
  try {
    composeModal?.hide();
  } finally {
    // if hide event fails for any reason, force cleanup
    window.setTimeout(cleanupBackdrops, 50);
  }
}

function openCompose() {
  const el = document.getElementById("compose_mail");
  composeEl = el;
  composeModal = Modal.getOrCreateInstance(el, {
    backdrop: true,
    keyboard: true,
    focus: true,
  });
  composeModal.show();
}

function resetCompose() {
  toInput.value = "";
  ccInput.value = "";
  bccInput.value = "";
  subject.value = "";
  body.value = "";
  emailStore.draftId = null;
  emailStore.lastDraftSavedAt = null;
  isDraftDirty.value = false;
  emailStore.attachments = [];
}

async function sendNow() {
  const to = parseEmails(toInput.value);
  const cc = parseEmails(ccInput.value);
  const bcc = parseEmails(bccInput.value);

  if (!to.length) return toast("Add at least 1 recipient", "error");

  const payload = {
    to,
    cc,
    bcc,
    subject: subject.value,
    body_text: body.value,
    attachment_ids: emailStore.attachments.map((a) => a.id),
  };

  if (draftId.value) {
    await emailStore.sendDraft(draftId.value, payload);
  } else {
    await emailStore.sendEmail(payload);
  }

  closeCompose();
  resetCompose();
}

async function saveDraftNow() {
  const payload = {
    to: parseEmails(toInput.value),
    cc: parseEmails(ccInput.value),
    bcc: parseEmails(bccInput.value),
    subject: subject.value,
    body_text: body.value,
  };

  const hasSomething =
    payload.to.length ||
    payload.cc.length ||
    payload.bcc.length ||
    (payload.subject || "").trim() ||
    (payload.body_text || "").trim();

  if (!hasSomething) return;

  if (!draftId.value) await emailStore.createDraft(payload);
  else await emailStore.updateDraft(draftId.value, payload);

  isDraftDirty.value = false;
}

function scheduleAutosave() {
  isDraftDirty.value = true;
  if (autosaveTimer.value) clearTimeout(autosaveTimer.value);
  autosaveTimer.value = setTimeout(async () => {
    try {
      if (isDraftDirty.value) await saveDraftNow();
    } catch {
      // store already toasts on failure
    }
  }, 1200);
}

/* =========================
   Attachment upload
========================= */
const fileInput = ref(null);

function pickFiles() {
  fileInput.value?.click();
}

async function onFilesPicked(e) {
  const files = e.target.files;
  if (!files || !files.length) return;

  // attach to draft if exists, else upload unattached
  await emailStore.uploadAttachments({ files, emailId: draftId.value });

  e.target.value = "";
}

async function openPreview(att) {
  const tempUrl = await emailStore.getPreviewUrl(att);
  window.open(tempUrl || att.url, "_blank");
}

// =========================
// Recipient suggestions
// =========================
const recipients = ref([]); // [{id, name, email}]
const recipientQuery = ref("");

const showSuggest = ref({ to: false, cc: false, bcc: false });
const activeRecipientField = ref(null);

function lastToken(str) {
  const s = String(str || "");
  const parts = s.split(",");
  return (parts[parts.length - 1] || "").trim();
}

const filteredRecipients = computed(() => {
  const q = (recipientQuery.value || "").toLowerCase().trim();
  if (!q) return [];
  return recipients.value
    .filter((u) => {
      const name = (u.name || "").toLowerCase();
      const email = (u.email || "").toLowerCase();
      return name.includes(q) || email.includes(q);
    })
    .slice(0, 8);
});

function onRecipientInput(field) {
  activeRecipientField.value = field;

  const value =
    field === "to"
      ? toInput.value
      : field === "cc"
      ? ccInput.value
      : bccInput.value;

  recipientQuery.value = lastToken(value);

  showSuggest.value = {
    to: field === "to" && !!recipientQuery.value,
    cc: field === "cc" && !!recipientQuery.value,
    bcc: field === "bcc" && !!recipientQuery.value,
  };

  scheduleAutosave();
}

function onRecipientFocus(field) {
  activeRecipientField.value = field;
  const value =
    field === "to"
      ? toInput.value
      : field === "cc"
      ? ccInput.value
      : bccInput.value;

  recipientQuery.value = lastToken(value);
  showSuggest.value[field] = !!recipientQuery.value;
}

function onRecipientBlur() {
  // allow click selection (mousedown.prevent above helps, this is extra safety)
  setTimeout(() => {
    showSuggest.value = { to: false, cc: false, bcc: false };
  }, 150);
}

function insertEmailIntoField(field, email) {
  const refMap = { to: toInput, cc: ccInput, bcc: bccInput };
  const r = refMap[field];
  const current = String(r.value || "");
  const parts = current.split(",");
  parts[parts.length - 1] = ` ${email}`; // replace last token
  const next = parts
    .map((p) => p.trim())
    .filter(Boolean)
    .join(", ");
  r.value = next ? `${next}, ` : `${email}, `;
}

function pickRecipient(field, email) {
  insertEmailIntoField(field, email);
  recipientQuery.value = "";
  showSuggest.value[field] = false;
  scheduleAutosave();
}

async function onDeleteEmail(item) {
  if (!item?.id) return;
  if (!confirm("Delete this email?")) return;
  await emailStore.deleteEmail(item.id);
}

onMounted(async () => {
  autosaveTicker = window.setInterval(() => {
    nowTick.value = Date.now();
  }, 3000);

  await emailStore.fetchLabels();
  await emailStore.fetchEmails();

  // ✅ preload recipients for suggestions
  try {
    if (!userStore.users?.length) await userStore.fetchUsers?.();
    recipients.value = (userStore.users || [])
      .map((u) => ({
        id: u.id,
        name: u.name || `${u.first_name || ""} ${u.last_name || ""}`.trim(),
        first_name: u.first_name,
        email: u.email,
      }))
      .filter((u) => u.email);
  } catch {
    recipients.value = [];
  }

  // ✅ Wire modal lifecycle: reset only AFTER it is hidden (cleanest UX)
  composeEl = document.getElementById("compose_mail");
  if (composeEl) {
    composeEl.addEventListener("hidden.bs.modal", () => {
      // after close: reset + clear overlays
      resetCompose();
      cleanupBackdrops();
    });

    // extra safety if someone force-closes quickly
    composeEl.addEventListener("hide.bs.modal", () => {
      window.setTimeout(cleanupBackdrops, 50);
    });
  }
});

onUnmounted(() => {
  if (autosaveTicker) window.clearInterval(autosaveTicker);
  // ✅ prevent stale overlays when navigating away
  cleanupBackdrops();
});




</script>

<style scoped>
/* ---------- Compose Modal: Layout ---------- */
.dq-compose :deep(.modal-dialog) {
  max-width: 980px;
}

.dq-compose-card {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(16, 24, 40, 0.18);
}

/* Header */
.dq-compose-header {
  background: linear-gradient(135deg, #0b1220, #111827);
  border: 0;
  padding: 16px 18px;
}

.dq-compose-icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 18px;
}

.dq-compose-header .modal-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.dq-compose-subtitle {
  color: rgba(255, 255, 255, 0.75);
  max-width: 520px;
}

.dq-compose-close {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}
.dq-compose-close:hover {
  background: rgba(255, 255, 255, 0.12);
}

.dq-compose-draft-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  white-space: nowrap;
}

/* Body */
.dq-compose-body {
  padding: 18px;
  background: #ffffff;
  max-height: calc(100vh - 240px);
  overflow: auto;
}

.dq-section-title {
  font-weight: 700;
  color: #0f172a;
}

/* Inputs */
.dq-input-wrap {
  position: relative;
}
.dq-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  font-size: 16px;
  pointer-events: none;
}
.dq-input {
  padding-left: 40px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
}
.dq-input:focus {
  border-color: rgba(59, 130, 246, 0.55);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

.dq-textarea {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}
.dq-textarea:focus {
  border-color: rgba(59, 130, 246, 0.55);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

/* Suggestions */
.dq-suggest {
  max-height: 280px;
  overflow: auto;
}
.dq-suggest-panel {
  z-index: 1056;
  border-radius: 14px;
}
.dq-suggest .dropdown-item {
  text-align: left;
  border-radius: 10px;
}
.dq-suggest .dropdown-item:hover {
  background: #f8fafc;
}
.dq-suggest-avatar {
  background: #eef2ff;
  color: #3730a3;
  border: 1px solid #e5e7eb;
}

/* Attachments */
.dq-attach-btn {
  border-radius: 12px;
}

.dq-attach-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.dq-attach-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  max-width: 100%;
}

.dq-attach-ic {
  color: #334155;
}

.dq-attach-name {
  max-width: 340px;
  color: #0f172a;
  font-weight: 600;
}

.dq-attach-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.dq-attach-action {
  display: inline-flex;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #334155;
  text-decoration: none;
}
.dq-attach-action:hover {
  background: #f1f5f9;
}
.dq-attach-action.danger {
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.25);
}
.dq-attach-action.danger:hover {
  background: rgba(185, 28, 28, 0.06);
}

.dq-empty-attach {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px;
  border-radius: 14px;
  border: 1px dashed #e5e7eb;
  background: #fbfdff;
  color: #475569;
}
.dq-empty-attach i {
  font-size: 18px;
  color: #64748b;
}

/* Footer */
.dq-compose-footer {
  border-top: 1px solid #eef2f7;
  background: #fff;
  padding: 14px 18px;
}

.dq-btn {
  border-radius: 12px;
  padding: 10px 14px;
}

.dq-btn-primary {
  border-radius: 12px;
  padding: 10px 16px;
  box-shadow: 0 10px 24px rgba(59, 130, 246, 0.18);
}

/* keep your existing styles too if needed */
.mails-list .list-group-item.bg-light {
  background: #f8f9fa !important;
}

/* Chips */
.dq-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dq-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #0f172a;
  max-width: 100%;
}

.dq-chip i {
  color: #334155;
}

.dq-chip-x {
  border: 0;
  background: transparent;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}
.dq-chip-x:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
}
.dq-chip-x:disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Dropzone */
.dq-dropzone {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px;
  border-radius: 14px;
  border: 1px dashed #e5e7eb;
  background: #fbfdff;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s ease;
}
.dq-dropzone i {
  font-size: 18px;
  color: #64748b;
}
.dq-dropzone:hover {
  background: #f8fafc;
  border-color: rgba(59, 130, 246, 0.35);
}
.dq-dropzone.is-over {
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.6);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}
.dq-dropzone.is-disabled {
  opacity: 0.6;
  pointer-events: none;
}
.dq-dropzone-text {
  line-height: 1.1;
}

/* Autosave pill polish */
.dq-compose-draft-pill i.ti-loader {
  animation: dqspin 1s linear infinite;
}

@keyframes dqspin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

</style>


